import { createSelector } from 'reselect';
import { sortBy } from 'lodash';
import { getActiveDetailedInformationTab } from '../../selectors';
import { createErrorDataSelector } from 'selectors/selectorUtils';
import { apiCallStatus } from 'helpers/constants';

const getDateSelection = ({ overview }) => {
    return overview?.dateSelection;
};

const getSelectedHistogramKPIData = ({ operationalParameters }) => {
    return operationalParameters?.histogramV2?.data;
};

const getHistogramDataAndConfig = createSelector([
    getSelectedHistogramKPIData
],
    (data) => {
        return data?.length ?
            {
                histogramData: data[0].values,
                histogramDataConfig: data[0].config
            }
            : {
                histogramData: [],
                histogramDataConfig: null
            };
    });

const getHistogramLoadingStatus = ({ operationalParameters }) => {
    return operationalParameters?.histogramV2?.loadingStatus;
};

const getHistogramKpisData = ({ operationalParameters }) => {
    const kpis = operationalParameters?.histogramV2Kpis?.data;
    return sortBy(kpis, kpi => kpi.name?.toLowerCase());
};

const getHistogramKpisLoadingStatus = ({ operationalParameters }) => {
    return operationalParameters?.histogramV2Kpis?.loadingStatus;
};

const getSelectedKpi = ({ operationalParameters }) => {
    return operationalParameters?.selectedHistogramV2KPI;
};

const getRawHistogramErrorData = ({ operationalParameters }) => {
    if (operationalParameters?.histogramV2Kpis?.loadingStatus === apiCallStatus.ERROR) {
        return {
            loadingStatus: operationalParameters.histogramV2Kpis.loadingStatus,
            error: operationalParameters.histogramV2Kpis.error,
            errorCode: operationalParameters.histogramV2Kpis.error?.statusCode,
        };
    }
    if (operationalParameters?.histogramV2?.loadingStatus === apiCallStatus.ERROR) {
        return {
            loadingStatus: operationalParameters.histogramV2.loadingStatus,
            error: operationalParameters.histogramV2.error,
            errorCode: operationalParameters.histogramV2.error?.statusCode,
        };
    }
    return { loadingStatus: operationalParameters?.histogramV2?.loadingStatus };
};

const getHistogramErrorData = createErrorDataSelector(getRawHistogramErrorData);

export const getModel = createSelector([
    getActiveDetailedInformationTab,
    getDateSelection,
    getHistogramDataAndConfig,
    getHistogramLoadingStatus,
    getHistogramKpisData,
    getHistogramKpisLoadingStatus,
    getSelectedKpi,
    getHistogramErrorData,
],
    (
        activeDetailedInformationTab,
        dateSelection,
        histogramDataAndConfig,
        histogramDataLoadingStatus,
        histogramKpis,
        histogramKpisLoadingStatus,
        selectedKpi,
        errorData,
    ) => {
        return {
            activeDetailedInformationTab,
            dateSelection,
            ...histogramDataAndConfig,
            histogramDataLoadingStatus,
            histogramKpis,
            histogramKpisLoadingStatus,
            selectedKpi,
            errorData,
        };
    });
